import React from "react";
import SectorCRUDTable from "@/components/SectorCRUDTable";
import { HardHat } from "lucide-react";

const STATUS_LABELS = { planifie: "Planifié", en_cours: "En cours", termine: "Terminé", annule: "Annulé" };
const STATUS_COLORS = { planifie: "#D97706", en_cours: "#002FA7", termine: "#059669", annule: "#868E96" };

export default function ChefChantiers() {
  return (
    <SectorCRUDTable
      endpoint="/chef/secteur/chantiers"
      eyebrow="BTP · Chantiers"
      title="Gestion des chantiers"
      sub="Pilotez tous vos chantiers : équipes, dates, budgets, statut."
      testidPrefix="chantier"
      allowEdit
      defaultRow={() => ({ nom: "", adresse: "", client: "", debut: new Date().toISOString().slice(0, 10), fin: "", equipe: [], budget: 0, status: "planifie", notes: "" })}
      columns={[
        { key: "nom", label: "Chantier" },
        { key: "client", label: "Client", width: "160px" },
        { key: "debut", label: "Début", width: "120px", render: (v) => v ? new Date(v).toLocaleDateString("fr-FR") : "—" },
        { key: "fin", label: "Fin prévue", width: "120px", render: (v) => v ? new Date(v).toLocaleDateString("fr-FR") : "—" },
        { key: "budget", label: "Budget", width: "120px", render: (v) => <span className="font-mono">{(v || 0).toLocaleString("fr-FR")} €</span> },
        { key: "status", label: "Statut", width: "120px", render: (v) => (
          <span className="text-[10px] uppercase font-bold px-2 py-0.5" style={{ color: STATUS_COLORS[v], background: `${STATUS_COLORS[v]}15` }}>{STATUS_LABELS[v] || v}</span>
        )},
      ]}
      fields={[
        { key: "nom", label: "Nom du chantier", span: 8, required: true },
        { key: "status", label: "Statut", type: "select", span: 4, required: true, options: Object.entries(STATUS_LABELS).map(([v, l]) => ({ value: v, label: l })) },
        { key: "adresse", label: "Adresse", span: 8 },
        { key: "client", label: "Client", span: 4 },
        { key: "debut", label: "Date début", type: "date", span: 4, required: true },
        { key: "fin", label: "Date fin prévue", type: "date", span: 4 },
        { key: "budget", label: "Budget (€)", type: "number", step: "0.01", span: 4 },
        { key: "notes", label: "Notes", type: "textarea", span: 12 },
      ]}
      emptyIcon={HardHat}
      emptyText="Aucun chantier. Cliquez sur Ajouter pour créer le premier."
    />
  );
}
